import { Api, downloadFile, ApiDownloadFile } from "../../common/lib/httpRequest";
import {
  FilterEkycRequest,
  FilterEkycResponse,
  ImportEkycRequest,
  ImportEkycResponse,
  SendEmailEkycResultRequest,
  SendEmailEkycResultResponse,
  FilterHealthCheckRequest,
  FilterHealthCheckResponse,
  FilterOptionsResponse,
  ConfirmBatchHealthCheckRequest,
  SendEmailBatchHealthCheckRequest,
  GetPersonalHealthCheckDetailsRequest,
  ConfirmHealthCheckRequest,
  SendEmailHealthCheckRequest
} from "../utils/types";

export const apiFilterEkyc = (data: FilterEkycRequest): Promise<FilterEkycResponse> => {
  return Api.post(`api/v1/customer/user-ekyc`, data);
};

export const apiDownloadEkyc = (method: string, data: any, file_name: string): Promise<any> => {
  return downloadFile(
    method,
    `${process.env.REACT_APP_BASE_API_URL}api/v1/customer/user-ekyc/export`,
    data,
    file_name
  );
};

export const apiDownloadPdfEkyc = (id: any, file_name: string): Promise<any> => {
  return downloadFile(
    'GET',
    `${process.env.REACT_APP_BASE_API_URL}api/v1/customer/v2/user-ekyc/review/pdf/${id}`,
    null,
    file_name
  );
};

export const apiDownloadHealthCheck = (method: string, data: any, file_name: string): Promise<any> => {
  return downloadFile(
    method,
    `${process.env.REACT_APP_BASE_API_URL}api/v2/customer/user-ekyc/export`,
    data,
    file_name
  );
};

export const apiImportEkyc = (data: ImportEkycRequest): Promise<ImportEkycResponse> => {
  return Api.post(`api/v1/customer/user-ekyc/import-result`, data);
};

export const apiSendEmailEkycResult = (data: SendEmailEkycResultRequest): Promise<SendEmailEkycResultResponse> => {
  return Api.post(`api/v1/customer/user-ekyc/trigger/send-mail-result`);
};

export const apiFilterHealthCheck = (data: FilterHealthCheckRequest): Promise<FilterHealthCheckResponse> => {
  return Api.post(`api/v2/customer/user-ekyc`, data);
};

export const apiGetFilterOptions = (data: null): Promise<FilterOptionsResponse> => {
  return Api.get(`api/v2/customer/user-ekyc/filter-options`, data);
};

export const apiConfirmBatchHealthCheck = (data: ConfirmBatchHealthCheckRequest): Promise<FilterOptionsResponse> => {
  return Api.post(`api/v1/customer/v2/user-ekyc/review/batch?ids=${data}`);
};

export const apiSendEmailBatchHealthCheck = (data: SendEmailBatchHealthCheckRequest): Promise<FilterOptionsResponse> => {
  return Api.post(`api/v1/customer/v2/user-ekyc/email/batch?ids=${data}`);
};

export const apiGetPersonalHealthCheckDetails = (data: GetPersonalHealthCheckDetailsRequest): Promise<FilterOptionsResponse> => {
  return ApiDownloadFile.get(`api/v1/customer/v2/user-ekyc/review/png/${data}`, null);
};

export const apiConfirmHealthCheck = (data: ConfirmHealthCheckRequest): Promise<FilterOptionsResponse> => {
  return Api.post(`api/v1/customer/v2/user-ekyc/review/single`, data);
};

export const apiGetDetails = (data: GetPersonalHealthCheckDetailsRequest): Promise<FilterOptionsResponse> => {
  return Api.get(`api/v1/customer/v2/user-ekyc/detail/${data}`, null);
};

export const apiExportPdfDetails = (data: GetPersonalHealthCheckDetailsRequest): Promise<any> => {
  return ApiDownloadFile.get(`api/v1/customer/v2/user-ekyc/review/pdf/${data}`, null);
};
export const apiSendEmailHealthCheck = (data: SendEmailHealthCheckRequest): Promise<FilterOptionsResponse> => {
  return Api.post(`api/v1/customer/v2/user-ekyc/email/single/${data}`);
};

export const apiGetFilterEkycOptions = (data: null): Promise<FilterOptionsResponse> => {
  return Api.get(`api/v1/customer/user-ekyc/filter-options`, data);
};
